import { v1 as uuidV1 } from 'uuid';
import crypto from 'crypto-js';

const HASH_NAMESPACE = 'amex-apigee-hmac';

const getUniqueId = () => crypto.HmacSHA1(uuidV1(), HASH_NAMESPACE).toString(crypto.enc.Hex);

export default getUniqueId;
